// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"c07df68521091690ea0e","873":"50498d8321c2a30ee500"}[chunkId] + ".js";
};